"use strict";
import "lodash";
import { svc_fetchOne, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "xero/mapping";

const Model = {
	namespace: "m_XeroMapping",
	state: {
		mapping: {},
		mappings: [],
		codes: [],
		xeroOrganisations: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { mappings } }) {
			return { ...state, mappings };
		},
		handleFetchAllCodes(state, { payload: { codes } }) {
			return { ...state, codes };
		},
		handleFetchOne(state, { payload: { result } }) {
			return { ...state, mapping: result };
		},
		handleFetchAllOrgs(state, { payload }) {
			return { ...state, xeroOrganisations: payload };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let mappings = yield call(svc_search, `${endpointBasePrefix}`, payload);

			_.forEach(mappings.result, function (row) {
				row.key = row.id;

				// setting visibility of button
				if (row.xero_type === "ORGANISATION") {
					row.hideConfigBtn = false;
				} else {
					row.hideConfigBtn = true;
				}
			});

			yield put({
				type: "handleFetchAll",
				payload: { mappings },
			});
		},

		// xero get codes
		*fetchCodes({ payload }, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { search: payload.xero_code_id });
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.codeDescription = `${row.code} - ${row.name}`;
			});
			yield put({
				type: "handleFetchAllCodes",
				payload: { codes },
			});

			return codes;
		},

		*fetchAllTaxCode({ payload }, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { filter: { xeroType: "TAX_RATE", xeroOrgId: payload }, sort: { code: "asc" } });
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.taxDescription = `${row.code} - ${row.name}`;
			});
			return codes.result;
		},

		// not in use
		*fetchAllCompany({}, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`);
			let companyResult = [];
			for (let i = 0; i < codes.result.length; i++) {
				if (codes.result[i].xero_type === "TRACKING_OPTION") {
					companyResult.push(codes.result[i]);
					_.forEach(companyResult, (row) => {
						row.key = row.id;
						row.companyDescription = `${row.xero_id} - ${row.name}`;
					});
				}
			}
			const company = companyResult;

			return company;
		},

		*fetchAllContact({ payload }, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { filter: { xeroType: "CONTACT", xeroOrgId: payload }, sort: { code: "asc" } });
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.contactDescription = `${row.code} - ${row.name}`;
			});
			return codes.result;
		},

		*fetchAllAccount({ payload }, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { filter: { xeroType: "ACCOUNT", xeroOrgId: payload }, sort: { code: "asc" } });
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.accountDescription = `${row.code} - ${row.name}`;
			});
			return codes.result;
		},

		*fetchAllItem({ payload }, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { filter: { xeroType: "ITEM", xeroOrgId: payload }, sort: { code: "asc" } });
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.itemDescription = `${row.code} - ${row.name}`;
			});
			return codes.result;
		},

		*fetchAllTrackingCategories({ payload }, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { filter: { xeroType: "TRACKING_CATEGORY", xeroOrgId: payload }});
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.trackingDescription = row.name;
			});
			return codes.result;
		},

		*fetchAllTrackingOptions({ payload }, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { filter: { xeroType: "TRACKING_OPTION", xeroOrgId: payload.xero_org_id, xeroTrackingCat: payload.tracking_category_1_xero_id }, sort: { code: "asc" } });
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.trackingDescription = `${row.code} - ${row.name}`;
			});
			return codes.result;
		},

		*fetchAllOrg({}, { call, put }) {
			const codes = yield call(svc_search, `${endpointBasePrefix}/codes/all`, { filter: { xeroType: "ORGANISATION" }, sort: { code: "asc" }});
			_.forEach(codes.result, function (row) {
				row.key = row.id;
				row.orgDescription = row.name;
			});

			yield put({
				type: "handleFetchAllOrgs",
				payload: codes.result,
			});

			return codes.result;
		},

		*fetchOne({ searchKey }, { call, put }) {
			const response = yield call(svc_fetchOne, endpointBasePrefix, searchKey);
			showServerResponse(response, true);

			if (response.result) {
				_.forEach(response.result, (row) => {
					row.key = row.id;
				});

				const mapping = response.result[0];
				yield put({
					type: "handleFetchOne",
					payload: { mapping },
				});
				return mapping;
			}

			return null;
		},

		*addOne({ payload }, { call }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},

		*editOne({ payload }, { call }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
			return showServerResponse(response);
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname }) => {
				if (pathname.includes("/xero/mapping")) {
					dispatch({ type: "fetchAll" });
				}
			});
		},
	},
};

export default Model;
